import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function SsoCallback() {
  const [error, setError] = useState('');
  const { loginWithToken } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const token = searchParams.get('token');
    const userParam = searchParams.get('user');

    if (!token || !userParam) {
      setError('Invalid SSO callback. Missing authentication data.');
      return;
    }

    try {
      const user = JSON.parse(decodeURIComponent(userParam));
      loginWithToken(token, user);
      navigate('/dashboard', { replace: true });
    } catch (err) {
      setError('Failed to process SSO login. Please try again.');
    }
  }, [searchParams, loginWithToken, navigate]);

  if (error) {
    return (
      <div style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: 'var(--bg)', padding: 20
      }}>
        <div style={{
          background: 'var(--bg-card)', borderRadius: 16, boxShadow: 'var(--shadow-lg)',
          padding: 40, width: '100%', maxWidth: 440, border: '1px solid var(--border)', textAlign: 'center'
        }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>⚠️</div>
          <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 12 }}>SSO Login Failed</h2>
          <p style={{ color: 'var(--text-secondary)', fontSize: 14, marginBottom: 24 }}>{error}</p>
          <button onClick={() => navigate('/login')} style={{
            padding: '10px 24px', borderRadius: 8, border: 'none',
            background: 'var(--primary)', color: 'white', fontSize: 14, fontWeight: 600, cursor: 'pointer'
          }}>
            Back to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--bg)', padding: 20
    }}>
      <div style={{
        background: 'var(--bg-card)', borderRadius: 16, boxShadow: 'var(--shadow-lg)',
        padding: 40, width: '100%', maxWidth: 440, border: '1px solid var(--border)', textAlign: 'center'
      }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>🔐</div>
        <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 8 }}>Completing SSO Login...</h2>
        <p style={{ color: 'var(--text-secondary)', fontSize: 14 }}>Please wait while we sign you in.</p>
      </div>
    </div>
  );
}
